import React from 'react';
import PropTypes from 'prop-types';

import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import { InputBase, IconButton } from '@material-ui/core';

import { Container } from './styles';

const InputSearch = ({ searchText, setSearchText, handleSubmit }) => {
  function handleClear() {
    setSearchText('');
    handleSubmit(null, 1);
  }

  return (
    <Container>
      <SearchIcon />

      <InputBase
        fullWidth
        placeholder="Buscar paciente"
        value={searchText}
        onKeyDown={(e) => e.keyCode === 13 && handleSubmit(searchText, 1)}
        onChange={(event) => setSearchText(event.target.value)}
      />

      {searchText && (
        <IconButton onClick={handleClear}>
          <CloseIcon />
        </IconButton>
      )}
    </Container>
  );
};

InputSearch.propTypes = {
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default InputSearch;
